import { ChangeDetectionStrategy, Component } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { TasksService } from "../tasks/tasks.service";
import { UserHomeService } from "../userHome.service";
import { UserAuthenticationService, CurrentUserService } from "../../../services/shared";
import { UserHomeComponent } from "../userHome.component";
import { StaticUserDataService }        from "../../../services/staticUserData.service";
import { UserDetailsService }           from "./userDetails.service";



@Component({
    template: require("./forceContactInfoUpdate.component.html"),
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [require("./forceContactInfoUpdate.component.less").toString()],
    providers: [UserHomeService, TasksService, StaticUserDataService, UserDetailsService ]
})
export class ForceContactInfoUpdateComponent extends UserHomeComponent
{
 constructor(protected currentUserService: CurrentUserService, protected userAuthService: UserAuthenticationService,
    protected userHomeService: UserHomeService, protected cecRouter: Router,
    protected cecActivatedRoute: ActivatedRoute, protected taskService: TasksService) {
            super(currentUserService, userAuthService, userHomeService, cecRouter, cecActivatedRoute, taskService);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/userHome/userDetails/forceContactInfoUpdate.component.ts